// RestoreUserDialog.jsx
import React, { useState } from 'react';
import axios from 'axios';
import { BACKEND_URL_PORTAIL } from "../../../config/const.js";
import { useTranslation } from 'react-i18next';
import './Styles.css'
const RestoreUserDialog = ({ isOpen, handleClose, userId,fetchUserProfile }) => {

    const {t} = useTranslation();

    const [message, setMessage] = useState(null);
  // Function to handle user deletion
  const handleRestoreUser = async () => {
    const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const data={
        idUser:userId,
        idGroup: localStorage.getItem('currentOrg')
      }
    try {
      // Replace with your RestoreUser API endpoint
      const response = await axios.post(`${BACKEND_URL_PORTAIL}api/user/reactivate`,data,config);
      fetchUserProfile()
      setMessage({ type: 'success', text: t('successRestoreUser') });

      setTimeout(() => {
        setMessage(null); // Clear the message
        handleClose(); // Close the dialog
      }, 2000);
    } catch (error) {
      console.error('Error deleting user:', error);
      setMessage({ type: 'error', text: t('failureRestoreUser') });

      // Hide message after 2 seconds
      setTimeout(() => {
        setMessage(null); // Clear the message
      }, 2000);
    }
  };

  if (!isOpen) return null; // Don't render if the dialog is not open

  return (
    <>
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t('restoreUser')}</h5>
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            <p>{t('messageRestoreUser')}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
            >
              {t('cancel')}
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleRestoreUser}
            >
              {t('restoreUser')}
            </button>
          </div>
        </div>
      </div>
    </div>
        {/* Success/Failure message */}
        {message && (
            <div
              style={{
                position: 'fixed',
                bottom: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                padding: '10px 20px',
                backgroundColor: message.type === 'success' ? 'green' : '#ff3d60',
                color: 'white',
                borderRadius: '5px',
                zIndex: 1000,
                minWidth:"25%",
                textAlign:'center',
                transition: 'opacity 0.5s ease-in-out',
              }}
            >
              {message.text}
            </div>
          )}
          </>
  );
};

export default RestoreUserDialog;
